import { useState } from 'react';
import { toast } from 'react-toastify';
import { bulkAddWalkthroughsFromAPI } from 'src/services/client';
import {
  IBulkWalkthroughRequest,
  IBulkWalkthroughResponse,
} from 'src/services/client-types';

interface UseBulkWalkthroughsReturn {
  bulkWalkthroughsCreated: any[];
  isLoading: boolean;
  isBulkCreationSuccess: boolean;
  error: string | null;
  saveBulkWalkthroughs: (payload: IBulkWalkthroughRequest) => Promise<void>;
  clearBulkWalkthroughsState: () => void;
}

export const useBulkWalkthroughs = (): UseBulkWalkthroughsReturn => {
  const [bulkWalkthroughsCreated, setBulkWalkthroughsCreated] = useState<any[]>(
    []
  );
  const [isBulkCreationSuccess, setIsBulkCreationSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const saveBulkWalkthroughs = async (payload: IBulkWalkthroughRequest) => {
    try {
      setIsLoading(true);
      setError(null);

      const response: IBulkWalkthroughResponse =
        await bulkAddWalkthroughsFromAPI(payload);

      setBulkWalkthroughsCreated(response.data || []);
      setIsBulkCreationSuccess(true);
    } catch (err: any) {
      console.error('Failed to create bulk walkthroughs:', err);
      const errorMessage =
        err.message || 'Failed to create walkthroughs. Please try again.';
      setError(errorMessage);

      toast.error(errorMessage, {
        position: 'top-center',
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const clearBulkWalkthroughsState = () => {
    setBulkWalkthroughsCreated([]);
    setIsBulkCreationSuccess(false);
    setError(null);
  };

  return {
    bulkWalkthroughsCreated,
    isLoading,
    isBulkCreationSuccess,
    error,
    saveBulkWalkthroughs,
    clearBulkWalkthroughsState,
  };
};
